enum PaymentStatus {
	NoPayment = 0,
	ReadyToPay = 1,
	ToVerify = 2,
	Paid = 3,
	Rejected = 4
}

export default PaymentStatus;
